import {Pipe, PipeTransform} from '@angular/core';
import {StringsUtils} from '../utils/strings-utils';

@Pipe({
  name: 'split'
})
export class SplitPipe implements PipeTransform {

  transform(text: string, by: string, index: number = 0) {
    if (StringsUtils.isNotEmpty(text)) {
      const parts = text.split(by);
      return parts[index];
    }

    return '';
  }
}
